import CraftVars from './services/craftVars';
import breakpoints from './utils/breakpoints'
import IframeYoutube from './components/IframeYoutube/IframeYoutube'
import IframeVimeo from './components/IframeVimeo/IframeVimeo'
import ToggleElement from './utils/ToggleElement.js'
import {HeaderScroll} from './components/HeaderScroll/HeaderScroll';
import {ProductInfosPostLoader} from "./components/ProductInfosPostLoader/ProductInfosPostLoader";
import initMenuMobile from './components/Menu/MenuMobile'
import initMenuDesktop from './components/Menu/Menu'
import {HeadingModule} from './components/HeadingModule/HeadingModule'
import {Popup} from "./components/Popup/Popup";

import {Accordion} from "./components/Accordion/Accordion";
import {VideoGallery} from "./components/VideoGallery/VideoGallery";
import ProductFilter from "./components/ProductFilter/ProductFilter";
import {JobTeaser} from "./components/JobTeaser/JobTeaser";

import {FactSlider} from "./components/FactSlider/FactSlider";

customElements.define('iframe-youtube', IframeYoutube)
customElements.define('iframe-vimeo', IframeVimeo)

const ToggleTriggers = [...document.querySelectorAll('.toggle-trigger')]
for (let trigger of ToggleTriggers) {
  new ToggleElement(trigger)
}


initMenuMobile({menuBreakpoint: breakpoints.menu})
initMenuDesktop({
    largeWidth: breakpoints.menu,
    subNavDomEl: "UL"
})

if ('loading' in HTMLImageElement.prototype) {
    const images = [...document.querySelectorAll('img[loading="lazy"]')]
    for (let img of images) {
        if (img.dataset.src) {
            img.src = img.dataset.src
        }

        if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset
        }

        if (img.dataset.sizes) {
            img.sizes = img.dataset.sizes
        }
    }
} else {
    document.body.classList.add('loading-not-supported')
    // Dynamically import the LazySizes library
    const script = document.createElement('script')
    script.src = CraftVars.baseUrl + '/assets/js/lazysizes.js'
    document.body.appendChild(script)
}


// TODO example of header scroll behaviour


HeaderScroll()


document.addEventListener('DOMContentLoaded', function () {
    const langChooser = document.getElementById('lang-chooser');
    const selectElement = document.querySelector('.field--salutation select');

    if (langChooser) {
        langChooser.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];

            if (selectedOption) {
                window.location.href = selectedOption.value;
            }
        });
    }

    if (selectElement) {
        selectElement.addEventListener('change', function () {
            const selectedValue = this.value;
            if (!selectedValue) {
                this.classList.add('no-value');
            } else {
                this.classList.remove('no-value');
            }
        });
        checkSelectValue();
        function checkSelectValue(){
            if(selectElement.value == ""){
                selectElement.classList.add('no-value');
            }
        }
    }

});



Accordion();

ProductInfosPostLoader();
HeadingModule();

Popup();
VideoGallery();

FactSlider();

if( document.querySelector('.jobTeaser') ){
    JobTeaser();
}

new ProductFilter();
